import { BarChart2 } from 'lucide-react';
import { EsporaiTooltip } from 'components';
import { getCampaignStatusNameAndClass } from 'utils/campaignUtils';
import WhatsAppIcon from '../icons/WhatsAppIcon';
import GoogleIcon from '../icons/GoogleIcon';
import MetaIcon from '../icons/MetaIcon';

const CampaignCard = ({ name, platform, type, status = "default", onDetailsClicked, esporaiCampaign = false }) => {
  const getPlatformIcon = () => {
    if (platform === "google") {
      return <GoogleIcon width={30} height={30} />
    }
    if (platform === "meta") {
      if (type === "WHATSAPP_BUSINESS") {
        return <WhatsAppIcon width={30} height={30} />
      } 
      return <MetaIcon width={30} height={30} />
    }
    return null
  }

  const statusInfo = getCampaignStatusNameAndClass(status)

  return (
    <div onClick={onDetailsClicked} className="bg-background-card border border-gray-200 rounded-card flex flex-col justify-between min-h-[100px] transition-all  hover:shadow-card-hover group relative p-4 hover:cursor-pointer w-full max-w-full overflow-hidden">
      {/* Esquina superior derecha */}
      <div className="absolute top-3 right-3">
        {esporaiCampaign ? (
          <EsporaiTooltip position="left" content="Esta campaña ha sido creada por EsporAI">
            <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center">
              <img src="/isologo.blanco.png" alt="Campaign Logo Esporai" className="w-3 h-3" />
            </div>
         </EsporaiTooltip>
        ) : (
          <BarChart2 className="h-4 w-4 text-gray-muted" />
        )}
      </div>

      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        {getPlatformIcon()}
        <h3 className="text-sm font-medium text-text group-hover:text-primary transition pr-10 line-clamp-2 break-words">
          {name}
        </h3>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between mt-4">
        <span className={`text-xs px-2.5 py-0.5 rounded-full font-medium ${statusInfo.className}`}>
          {statusInfo.name}
        </span>
        <div className="flex gap-1.5">
          <button
            className="text-xs px-3 py-1 rounded-full bg-white border border-primary text-primary font-medium hover:bg-primary-hover hover:text-white transition-colors"
          >
            Detalles
          </button>
        </div>
      </div>
    </div>
  )
}

export default CampaignCard
